import { render, staticRenderFns } from "./SuggestedDatingChatItem.vue?vue&type=template&id=61125787&scoped=true"
import script from "./SuggestedDatingChatItem.vue?vue&type=script&lang=js"
export * from "./SuggestedDatingChatItem.vue?vue&type=script&lang=js"
import style0 from "./SuggestedDatingChatItem.vue?vue&type=style&index=0&id=61125787&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61125787",
  null
  
)

export default component.exports